<template>
  <section class="body">
    <!-- start: header -->
    <header class="header header-nav-menu header-nav-links">
      <div class="logo-container">
        <a href="../" class="logo">
          <img
            src="logo_sidebar.png"
            class="logo-image"
            width="90"
            height="24"
            alt="Porto Admin"
          />
          <img
            src="logo_login.png"
            class="logo-image-mobile"
            width="90"
            height="41"
            alt="Porto Admin"
          />
        </a>
        <button
          class="btn header-btn-collapse-nav d-lg-none"
          @click="toggleSidebarMob()"
        >
          <i class="fas fa-bars"></i>
        </button>

        <!-- start: header nav menu -->
        <!-- <div class="header-nav collapse">
          <div
            class="
              header-nav-main
              header-nav-main-effect-1
              header-nav-main-sub-effect-1
              header-nav-main-square
            "
          >
            <nav>
              <ul class="nav nav-pills" id="mainNav">
                <li class="">
                  <a class="nav-link" href="layouts-default.html">
                    Dashboard
                  </a>
                </li>
                <li class="dropdown">
                  <a class="nav-link dropdown-toggle" href="#"> Layouts </a>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="nav-link" href="index.html"> Landing Page </a>
                    </li>
                    <li>
                      <a class="nav-link" href="layouts-default.html">
                        Default
                      </a>
                    </li>
                    <li>
                      <a class="nav-link" href="layouts-modern.html">
                        Modern
                      </a>
                    </li>
                    <li class="dropdown-submenu">
                      <a class="nav-link"> Boxed </a>
                      <ul class="dropdown-menu">
                        <li>
                          <a class="nav-link" href="layouts-boxed.html">
                            Static Header
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-boxed-fixed-header.html"
                          >
                            Fixed Header
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li class="dropdown-submenu">
                      <a class="nav-link"> Horizontal Menu Header </a>
                      <ul class="dropdown-menu">
                        <li>
                          <a class="nav-link" href="layouts-header-menu.html">
                            Pills
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-header-menu-stripe.html"
                          >
                            Stripe
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-header-menu-top-line.html"
                          >
                            Top Line
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a class="nav-link" href="layouts-dark.html"> Dark </a>
                    </li>
                    <li>
                      <a class="nav-link" href="layouts-dark-header.html">
                        Dark Header
                      </a>
                    </li>
                    <li>
                      <a class="nav-link" href="layouts-two-navigations.html">
                        Two Navigations
                      </a>
                    </li>
                    <li class="dropdown-submenu">
                      <a class="nav-link"> Tab Navigation </a>
                      <ul class="dropdown-menu">
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-tab-navigation-dark.html"
                          >
                            Tab Navigation Dark
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-tab-navigation.html"
                          >
                            Tab Navigation Light
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-tab-navigation-boxed.html"
                          >
                            Tab Navigation Boxed
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a class="nav-link" href="layouts-light-sidebar.html">
                        Light Sidebar
                      </a>
                    </li>
                    <li>
                      <a
                        class="nav-link"
                        href="layouts-left-sidebar-collapsed.html"
                      >
                        Left Sidebar Collapsed
                      </a>
                    </li>
                    <li>
                      <a
                        class="nav-link"
                        href="layouts-left-sidebar-scroll.html"
                      >
                        Left Sidebar Scroll
                      </a>
                    </li>
                    <li class="dropdown-submenu">
                      <a class="nav-link"> Left Sidebar Big Icons </a>
                      <ul class="dropdown-menu">
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-left-sidebar-big-icons.html"
                          >
                            Left Sidebar Big Icons Dark
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-left-sidebar-big-icons-light.html"
                          >
                            Left Sidebar Big Icons Light
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li class="dropdown-submenu">
                      <a class="nav-link"> Left Sidebar Panel </a>
                      <ul class="dropdown-menu">
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-left-sidebar-panel.html"
                          >
                            Left Sidebar Panel Dark
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-left-sidebar-panel-light.html"
                          >
                            Left Sidebar Panel Light
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li class="dropdown-submenu">
                      <a class="nav-link"> Left Sidebar Sizes </a>
                      <ul class="dropdown-menu">
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-sidebar-sizes-xs.html"
                          >
                            Left Sidebar XS
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-sidebar-sizes-sm.html"
                          >
                            Left Sidebar SM
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="layouts-sidebar-sizes-md.html"
                          >
                            Left Sidebar MD
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a class="nav-link" href="layouts-square-borders.html">
                        Square Borders
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="dropdown">
                  <a class="nav-link dropdown-toggle" href="#"> Pages </a>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="nav-link" href="pages-signup.html"> Sign Up </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-signin.html"> Sign In </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-recover-password.html">
                        Recover Password
                      </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-lock-screen.html">
                        Locked Screen
                      </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-user-profile.html">
                        User Profile
                      </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-session-timeout.html">
                        Session Timeout
                      </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-calendar.html">
                        Calendar
                      </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-timeline.html">
                        Timeline
                      </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-media-gallery.html">
                        Media Gallery
                      </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-invoice.html">
                        Invoice
                      </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-blank.html">
                        Blank Page
                      </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-404.html"> 404 </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-500.html"> 500 </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-log-viewer.html">
                        Log Viewer
                      </a>
                    </li>
                    <li>
                      <a class="nav-link" href="pages-search-results.html">
                        Search Results
                      </a>
                    </li>
                  </ul>
                </li>
                <li class="dropdown dropdown-mega">
                  <a class="nav-link dropdown-toggle" href="#">UI Elements</a>
                  <ul class="dropdown-menu">
                    <li>
                      <div class="dropdown-mega-content">
                        <div class="row">
                          <div class="col-lg-3">
                            <ul class="dropdown-mega-sub-nav">
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-typography.html"
                                >
                                  Typography
                                </a>
                              </li>
                              <li>
                                <a class="nav-link" href="#">
                                  Icons
                                  <span
                                    class="
                                      mega-sub-nav-toggle
                                      toggled
                                      float-end
                                    "
                                    data-toggle="collapse"
                                    data-target=".mega-sub-nav-sub-menu-1"
                                  ></span>
                                </a>
                                <ul
                                  class="
                                    dropdown-mega-sub-nav
                                    mega-sub-nav-sub-menu-1
                                    collapse
                                    in
                                  "
                                >
                                  <li>
                                    <a
                                      class="nav-link"
                                      href="ui-elements-icons-elusive.html"
                                    >
                                      Elusive
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      class="nav-link"
                                      href="ui-elements-icons-font-awesome.html"
                                    >
                                      Font Awesome
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      class="nav-link"
                                      href="ui-elements-icons-line-icons.html"
                                    >
                                      Line Icons
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      class="nav-link"
                                      href="ui-elements-icons-meteocons.html"
                                    >
                                      Meteocons
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      class="nav-link"
                                      href="ui-elements-icons-box-icons.html"
                                    >
                                      Box Icons
                                    </a>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-tabs.html"
                                >
                                  Tabs
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-cards.html"
                                >
                                  Cards
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div class="col-lg-3">
                            <ul class="dropdown-mega-sub-nav">
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-widgets.html"
                                >
                                  Widgets
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-portlets.html"
                                >
                                  Portlets
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-buttons.html"
                                >
                                  Buttons
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-alerts.html"
                                >
                                  Alerts
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-notifications.html"
                                >
                                  Notifications
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-modals.html"
                                >
                                  Modals
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-lightbox.html"
                                >
                                  Lightbox
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-progressbars.html"
                                >
                                  Progress Bars
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div class="col-lg-3">
                            <ul class="dropdown-mega-sub-nav">
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-sliders.html"
                                >
                                  Sliders
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-carousels.html"
                                >
                                  Carousels
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-accordions.html"
                                >
                                  Accordions
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-toggles.html"
                                >
                                  Toggles
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-nestable.html"
                                >
                                  Nestable
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-tree-view.html"
                                >
                                  Tree View
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-scrollable.html"
                                >
                                  Scrollable
                                </a>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-grid-system.html"
                                >
                                  Grid System
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div class="col-lg-3">
                            <ul class="dropdown-mega-sub-nav">
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-charts.html"
                                >
                                  Charts
                                </a>
                              </li>
                              <li>
                                <a class="nav-link" href="#">
                                  Animations
                                  <span
                                    class="
                                      mega-sub-nav-toggle
                                      toggled
                                      float-end
                                    "
                                    data-toggle="collapse"
                                    data-target=".mega-sub-nav-sub-menu-2"
                                  ></span>
                                </a>
                                <ul
                                  class="
                                    dropdown-mega-sub-nav
                                    mega-sub-nav-sub-menu-2
                                    collapse
                                  "
                                >
                                  <li>
                                    <a
                                      class="nav-link"
                                      href="ui-elements-animations-appear.html"
                                    >
                                      Appear
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      class="nav-link"
                                      href="ui-elements-animations-hover.html"
                                    >
                                      Hover
                                    </a>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a class="nav-link" href="#">
                                  Loading
                                  <span
                                    class="
                                      mega-sub-nav-toggle
                                      toggled
                                      float-end
                                    "
                                    data-toggle="collapse"
                                    data-target=".mega-sub-nav-sub-menu-3"
                                  ></span>
                                </a>
                                <ul
                                  class="
                                    dropdown-mega-sub-nav
                                    mega-sub-nav-sub-menu-3
                                    collapse
                                  "
                                >
                                  <li>
                                    <a
                                      class="nav-link"
                                      href="ui-elements-loading-overlay.html"
                                    >
                                      Overlay
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      class="nav-link"
                                      href="ui-elements-loading-progress.html"
                                    >
                                      Progress
                                    </a>
                                  </li>
                                </ul>
                              </li>
                              <li>
                                <a
                                  class="nav-link"
                                  href="ui-elements-extra.html"
                                >
                                  Extra
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
                <li class="dropdown">
                  <a href="#" class="nav-link dropdown-toggle">More</a>
                  <ul class="dropdown-menu">
                    <li class="dropdown-submenu">
                      <a class="nav-link" href="#"> Maps </a>
                      <ul class="dropdown-menu">
                        <li>
                          <a class="nav-link" href="maps-google-maps.html">
                            Basic
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="maps-google-maps-builder.html"
                          >
                            Map Builder
                          </a>
                        </li>
                        <li>
                          <a class="nav-link" href="maps-vector.html">
                            Vector
                          </a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a class="nav-link" href="extra-ajax-made-easy.html">
                        Ajax
                      </a>
                    </li>
                    <li class="dropdown">
                      <a class="nav-link" href="#"> eCommerce </a>
                      <ul class="dropdown-menu">
                        <li>
                          <a class="nav-link" href="ecommerce-dashboard.html">
                            Dashboard
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="ecommerce-products-list.html"
                          >
                            Products List
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="ecommerce-products-form.html"
                          >
                            Products Form
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="ecommerce-category-list.html"
                          >
                            Categories List
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="ecommerce-category-form.html"
                          >
                            Category Form
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="ecommerce-coupons-list.html"
                          >
                            Coupons List
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="ecommerce-coupons-form.html"
                          >
                            Coupons Form
                          </a>
                        </li>
                        <li>
                          <a class="nav-link" href="ecommerce-orders-list.html">
                            Orders List
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="ecommerce-orders-detail.html"
                          >
                            Orders Detail
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="ecommerce-customers-list.html"
                          >
                            Customers List
                          </a>
                        </li>
                        <li>
                          <a
                            class="nav-link"
                            href="ecommerce-customers-form.html"
                          >
                            Customers Form
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div> -->
        <!-- end: header nav menu -->
      </div>

      <!-- start: search & user box -->
      <div class="header-right">
        <!-- <a
          class="btn search-toggle d-none d-md-inline-block d-xl-none"
          data-toggle-class="active"
          data-target=".search"
          ><i class="bx bx-search"></i
        ></a> -->
        <!-- <form
          action="pages-search-results.html"
          class="search search-style-1 nav-form d-none d-xl-inline-block"
        >
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="q"
              id="q"
              placeholder="Search..."
            />
            <button class="btn btn-default" type="submit">
              <i class="bx bx-search"></i>
            </button>
          </div>
        </form> -->

        <!-- <span class="separator"></span>
        <a
          class="dropdown-language nav-link"
          href="#"
          role="button"
          id="dropdownLanguage"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <img
            class="flag"
            :class="[`flag-${lang.flag}`]"
          />
          {{ lang.shortTitle.toUpperCase() }}
          <i class="fas fa-chevron-down"></i>
        </a>
        <div
          class="dropdown-menu dropdown-menu-right"
          aria-labelledby="dropdownLanguage"
        >
          <a
            class="dropdown-item"
            href="#"
            v-for="lang in languages"
            :key="lang.id"
            @click="setLanguage(lang.id)"
          >
            <img
              class="flag"
              :class="[`flag-${lang.flag}`]"
            />
            {{ lang.title }}
          </a>
        </div> -->

        <span class="separator"></span>

        <ul class="notifications">
          <li>
            <div class="dropdown-menu notification-menu large">
              <div class="notification-title">
                <span class="float-end badge badge-default">3</span>
                Tasks
              </div>

              <div class="content">
                <ul>
                  <li>
                    <p class="clearfix mb-1">
                      <span class="message float-start"
                        >Generating Sales Report</span
                      >
                      <span class="message float-end text-dark">60%</span>
                    </p>
                    <div class="progress progress-xs light">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        aria-valuenow="60"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style="width: 60%"
                      ></div>
                    </div>
                  </li>

                  <li>
                    <p class="clearfix mb-1">
                      <span class="message float-start">Importing Contacts</span>
                      <span class="message float-end text-dark">98%</span>
                    </p>
                    <div class="progress progress-xs light">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        aria-valuenow="98"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style="width: 98%"
                      ></div>
                    </div>
                  </li>

                  <li>
                    <p class="clearfix mb-1">
                      <span class="message float-start"
                        >Uploading something big</span
                      >
                      <span class="message float-end text-dark">33%</span>
                    </p>
                    <div class="progress progress-xs light mb-1">
                      <div
                        class="progress-bar"
                        role="progressbar"
                        aria-valuenow="33"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        style="width: 33%"
                      ></div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li>
            <div class="dropdown-menu notification-menu">

              <div class="content">
                <ul>
                  <li>
                    <a href="#" class="clearfix">
                      <span class="image image-as-text">{{
                        profile.firstName
                      }}</span>

                      <span class="title">Joseph Doe</span>
                      <span class="message">Lorem ipsum dolor sit.</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" class="clearfix">
                      <span class="image image-as-text bg-secondary">JJ</span>

                      <span class="title">Joseph Junior</span>
                      <span class="message truncate"
                        >Truncated message. Lorem ipsum dolor sit amet,
                        consectetur adipiscing elit. Donec sit amet lacinia
                        orci. Proin vestibulum eget risus non luctus. Nunc
                        cursus lacinia lacinia. Nulla molestie malesuada est ac
                        tincidunt. Quisque eget convallis diam, nec venenatis
                        risus. Vestibulum blandit faucibus est et malesuada. Sed
                        interdum cursus dui nec venenatis. Pellentesque non nisi
                        lobortis, rutrum eros ut, convallis nisi. Sed tellus
                        turpis, dignissim sit amet tristique quis, pretium id
                        est. Sed aliquam diam diam, sit amet faucibus tellus
                        ultricies eu. Aliquam lacinia nibh a metus bibendum, eu
                        commodo eros commodo. Sed commodo molestie elit, a
                        molestie lacus porttitor id. Donec facilisis varius
                        sapien, ac fringilla velit porttitor et. Nam tincidunt
                        gravida dui, sed pharetra odio pharetra nec. Duis
                        consectetur venenatis pharetra. Vestibulum egestas nisi
                        quis elementum elementum.</span
                      >
                    </a>
                  </li>
                  <li>
                    <a href="#" class="clearfix">
                      <span class="image image-as-text bg-tertiary">MD</span>

                      <span class="title">Monica Doe</span>
                      <span class="message">Lorem ipsum dolor sit.</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" class="clearfix">
                      <span class="image image-as-text bg-quaternary">RD</span>

                      <span class="title">Robert Doe</span>
                      <span class="message">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Donec sit amet lacinia orci. Proin vestibulum eget risus
                        non luctus. Nunc cursus lacinia lacinia. Nulla molestie
                        malesuada est ac tincidunt. Quisque eget convallis diam.
                      </span>
                    </a>
                  </li>
                </ul>

                <hr />

                <div class="text-end">
                  <a href="#" class="view-more">View All</a>
                </div>
              </div>
            </div>
          </li>
          <li>
            <a
              href="#"
              class="dropdown-toggle notification-icon"
              data-bs-toggle="dropdown"
            >
              <i class="bx bx-bell"></i>
              <span class="badge">3</span>
            </a>

            <div class="dropdown-menu notification-menu">
              <div class="notification-title">
                <span class="float-end badge badge-default">3</span>
                Alerts
              </div>

              <div class="content">
                <ul>
                  <li>
                    <a href="#" class="clearfix">
                      <div class="image">
                        <i class="bx bx-dislike bg-danger"></i>
                      </div>
                      <span class="title">Server is Down!</span>
                      <span class="message">Just now</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" class="clearfix">
                      <div class="image">
                        <i class="bx bx-lock-alt bg-warning"></i>
                      </div>
                      <span class="title">User Locked</span>
                      <span class="message">15 minutes ago</span>
                    </a>
                  </li>
                  <li>
                    <a href="#" class="clearfix">
                      <div class="image">
                        <i class="bx bx-wifi bg-success"></i>
                      </div>
                      <span class="title">Connection Restaured</span>
                      <span class="message">10/10/2021</span>
                    </a>
                  </li>
                </ul>

                <hr />

                <div class="text-end">
                  <a href="#" class="view-more">View All</a>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <span class="separator"></span>

        <div id="userbox" class="userbox">
          <a href="#" data-bs-toggle="dropdown">
            <span class="profile-picture profile-picture-as-text">{{
              profileInitials
            }}</span>
            <div
              class="profile-info profile-info-no-role"
              data-lock-name="John Doe"
              data-lock-email="johndoe@okler.com"
            >
              <span class="name">
                Hi,
                <strong class="font-weight-semibold">{{
                  `${profile.firstName} ${profile.lastName}`
                }}</strong>
              </span>
            </div>

            <i class="fas fa-chevron-down text-color-dark"></i>
          </a>

          <div class="dropdown-menu">
            <ul class="list-unstyled mt-3">
              <li>
                <router-link
                  role="menuitem"
                  tabindex="-1"
                  :to="{ name: 'UserProfile' }"
                  exact
                >
                  <i class="bx bx-user"></i> {{ translations.myProfile }}
                </router-link>
              </li>
              <li>
                <router-link :to="{ name: 'LogOut' }">
                  <i class="bx bx-log-out"></i> {{ translations.logout }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- end: search & user box -->
    </header>
    <!-- end: header -->

    <div class="inner-wrapper">
      <!-- start: sidebar -->
      <aside id="sidebar-left" class="sidebar-left">
        <div class="sidebar-header">
          <div class="sidebar-toggle d-none d-md-flex" @click="toggleSidebar()">
            <i class="fas fa-bars" aria-label="Toggle sidebar"></i>
          </div>
        </div>

        <div class="nano">
          <div class="nano-content">
            <nav id="menu" class="nav-main" role="navigation">
              <ul class="nav nav-main">
                <li>
                  <router-link
                    class="nav-link"
                    exact
                    :to="{ name: 'Dashboard' }"
                  >
                    <i class="bx bx-home-alt" aria-hidden="true"></i>
                    <span>{{ translations.homePageTitle }}</span>
                  </router-link>
                </li>
                <li class="nav-group-label">eCommerce</li>
                <li class="nav-parent nav-expanded" v-if="hasPermission('Vidi \'Osnovno\'')">
                  <a class="nav-link" href="#">
                    <i class="bx bx-grid" aria-hidden="true"></i>
                    <span>Osnovno</span>
                  </a>
                  <ul class="nav nav-children">
                    <li v-if="hasPermission('Vidi države')">
                      <router-link
                        class="nav-link"
                        exact
                        :to="{ name: 'Countries' }"
                      >
                        - {{ translations.countries }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi gradove')">
                      <router-link
                        class="nav-link"
                        exact
                        :to="{ name: 'Towns' }"
                      >
                        - {{ translations.towns }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi banke')">
                      <router-link
                        class="nav-link"
                        exact
                        :to="{ name: 'Banks' }"
                      >
                        - {{ translations.banks }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi valute')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Currencies' }"
                      >
                        - {{ translations.currencies }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi jedinice mjere')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'MeasurementUnits' }"
                      >
                        - {{ translations.measurementUnits }}
                      </router-link>
                    </li>
                  </ul>
                </li>

                <li class="nav-parent" v-if="hasPermission('Vidi \'Klijenti\'')">
                  <a class="nav-link" href="#">
                    <i class="bx bxs-user-detail"></i>
                    <span>Klijenti</span>
                  </a>
                  <ul class="nav nav-children">
                    <li v-if="hasPermission('Vidi kompanije')">
                      <router-link
                        class="nav-link"
                        exact
                        :to="{ name: 'Companies' }"
                      >
                        - {{ translations.companies }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi korisnike sistema')">
                      <router-link
                        class="nav-link"
                        exact
                        :to="{ name: 'Users' }"
                      >
                        - {{ translations.users }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi bankovne račune')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'CustomerBankAccounts' }"
                      >
                        - {{ translations.customerBankAccounts }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi korisničke datoteke')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'CustomerFiles' }"
                      >
                        - Korisničke datoteke
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi zahtjeve za promjenom osobnih podataka')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'PersonalDataChangeRequests' }"
                      >
                        - Zahtjevi - osobni podaci
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'CustomerRequests' }"
                      >
                        - Korisnički zahtjevi
                      </router-link>
                    </li>
                  </ul>
                </li>

                <li class="nav-parent" v-if="hasPermission('Vidi \'Proizvodi\'')">
                  <a class="nav-link" href="#">
                    <i class="fa fa-newspaper" aria-hidden="true"></i>
                    <span>Proizvodi</span>
                  </a>
                  <ul class="nav nav-children">
                    <li v-if="hasPermission('Vidi kategorije')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Categories' }"
                      >
                        - {{ translations.categories }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi artikle')">
                      <router-link
                        class="nav-link"
                        exact
                        :to="{ name: 'Articles' }"
                      >
                        - {{ translations.articles }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi zahtjeve za prezentacijom proizvoda')">
                      <router-link
                        class="nav-link"
                        exact
                        :to="{ name: 'PresentationRequests' }"
                      >
                        - Zahtjevi za prezentaciju
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi atribute')">
                      <router-link
                        class="nav-link"
                        exact
                        :to="{ name: 'Attributes' }"
                      >
                        - {{ translations.attributes }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi akcije')">
                      <router-link
                        class="nav-link"
                        exact
                        :to="{ name: 'ProductSales' }"
                      >
                        - {{ translations.productSales }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi tabove')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Tabs' }"
                      >
                        - {{ translations.tabs }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi brendove')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Brands' }"
                      >
                        - {{ translations.brands }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi područja interesovanja')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'InterestsAreas' }"
                      >
                        - {{ translations.interestsAreas }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi tagove')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Tags' }"
                      >
                        - {{ translations.tags }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi media biblioteku')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'MediaLibrary' }"
                      >
                        - Biblioteka
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi recenzije')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Reviews' }"
                      >
                        - Recenzije
                      </router-link>
                    </li>
                  </ul>
                </li>

                <li class="nav-parent" v-if="hasPermission('Vidi \'Dokumenti\'')">
                  <a class="nav-link" href="#">
                    <i class="fa fa-newspaper" aria-hidden="true"></i>
                    <span>Dokumenti</span>
                  </a>
                  <ul class="nav nav-children">
                    <!-- <li v-if="hasPermission('Vidi ponude')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Offers' }"
                      >
                        - {{ translations.offers }}
                      </router-link>
                    </li> -->
                    <li v-if="hasPermission('Vidi ponude')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'AdvancedOffers' }"
                      >
                        <!-- - {{ translations.advancedOffers }} -->
                        - {{ translations.offers }}
                      </router-link>
                    </li>
                    <!-- <li v-if="getShowOffers && hasPermission('Vidi ponude')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Offers' }"
                      >
                        - {{ translations.offers }}
                      </router-link>
                    </li>

                    <li v-if="getShowAdvancedOffers && hasPermission('Vidi ponude')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'AdvancedOffers' }"
                      >
                        - {{ translations.advancedOffers }}
                      </router-link>
                    </li> -->
                  </ul>
                </li>

                <li class="nav-parent" v-if="hasPermission('Vidi \'Narudžbe\'')">
                  <a class="nav-link" href="#">
                    <i class="bx bx-cart-alt" aria-hidden="true"></i>
                    <span>Narudžbe</span>
                  </a>
                  <ul class="nav nav-children">
                    <li v-if="hasPermission('Vidi narudžbe')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Orders' }"
                      >
                        - {{ translations.orders }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi artikle u košarici')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'OrderArticles' }"
                      >
                        - {{ translations.orderArticles }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi artikle u košarici')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'WishLists' }"
                      >
                        - {{ translations.wishLists }}
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi artikle')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'OutOfStockArticles' }"
                      >
                        - Artikli na upit
                      </router-link>
                    </li>
                    <li v-if="hasPermission('Vidi brze pošte')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'ExpressPosts' }"
                      >
                        - {{ translations.expressPosts }}
                      </router-link>
                    </li>
                  </ul>
                </li>

                <li class="nav-parent" v-if="hasPermission('Vidi \'Postavke početne stranice\'')">
                  <a class="nav-link" href="#">
                    <i class="bx bxs-customize" aria-hidden="true"></i>
                    <span>Postavke početne stranice</span>
                  </a>
                  <ul class="nav nav-children">
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Sliders' }"
                      >
                        - Postavke glavnih slidera
                      </router-link>
                    </li>

                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'FeaturedCategories' }"
                      >
                        - Izdvojeno
                      </router-link>
                    </li>

                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Banners' }"
                      >
                        - Banneri
                      </router-link>
                    </li>

                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'HighlightedBrands' }"
                      >
                        - Istaknuti brend
                      </router-link>
                    </li>

                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'TopBrands' }"
                      >
                        - Top brendovi
                      </router-link>
                    </li>

                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'FooterSettings' }"
                      >
                        - Footer
                      </router-link>
                    </li>

                    <li v-if="hasPermission('Vidi artikle')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'NewArticles' }"
                      >
                        - Novi artikli
                      </router-link>
                    </li>
                  </ul>
                </li>

                <li class="nav-parent" v-if="hasPermission('Vidi \'Sistemske poruke\'')">
                  <a class="nav-link" href="#">
                    <i class="bx bxs-customize" aria-hidden="true"></i>
                    <span>Sistemske poruke</span>
                  </a>
                  <ul class="nav nav-children">
                    <li v-if="hasPermission('Vidi sistemske poruke')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'SystemMessages' }"
                      >
                        - Sistemske poruke
                      </router-link>
                    </li>
                  </ul>
                </li>

                <li class="nav-parent" v-if="hasPermission('Vidi \'Korisničke uloge\'')">
                  <a class="nav-link" href="#">
                    <i class="bx bxs-customize" aria-hidden="true"></i>
                    <span>Korisničke uloge</span>
                  </a>
                  <ul class="nav nav-children">
                    <li v-if="hasPermission('Vidi korisnička prava')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'UserRoles' }"
                      >
                        - Uloge korisnika
                      </router-link>
                    </li>
                  </ul>
                </li>

                <li class="nav-parent" v-if="hasPermission('Vidi \'Planovi čišćenja\'')">
                  <a class="nav-link" href="#">
                    <i class="bx bxs-component" aria-hidden="true"></i>
                    <span>Planovi čišćenja</span>
                  </a>
                  <ul class="nav nav-children">
                    <li v-if="hasPermission('Vidi planove čišćenja')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'CleaningPlans' }"
                      >
                        - Plan čišćenja
                      </router-link>
                    </li>

                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'CleaningAreas' }"
                      >
                        - Područje primjene
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        class="nav-link"
                        exact
                        :to="{ name: 'CleaningNoteIcons' }"
                      >
                        - Ikonice planova
                      </router-link>
                    </li>

                  </ul>
                </li>

                <li class="nav-parent" v-if="hasPermission('Vidi \'Ostalo\'')">
                  <a class="nav-link" href="#">
                    <i class="bx bxs-component" aria-hidden="true"></i>
                    <span>Ostalo</span>
                  </a>
                  <ul class="nav nav-children">
                    <li v-if="hasPermission('Vidi novosti')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Blogs' }"
                      >
                        - {{ translations.blogs }}
                      </router-link>
                    </li>

                    <li v-if="hasPermission('Vidi ankete')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Polls' }"
                      >
                        - {{ translations.polls }}
                      </router-link>
                    </li>

                    <li v-if="hasPermission('Vidi kodove za popust pri kupovini')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Coupons' }"
                      >
                        - {{ translations.coupons }}
                      </router-link>
                    </li>

                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Terms' }"
                      >
                        - {{ translations.terms }}
                      </router-link>
                    </li>

                    <li v-if="hasPermission('Vidi voditelje servisa')">
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'ServiceManagers' }"
                      >
                        - Voditelji servisa
                      </router-link>
                    </li>

                    <li v-if="hasPermission('Vidi reklamacije')">
                      <router-link exact class="nav-link" :to="{ name: 'RMA' }">
                        - {{ translations.rma }}
                      </router-link>
                    </li>

                    <li v-if="hasPermission('Vidi kodove za popust pri kupovini')">
                      <router-link exact class="nav-link" :to="{ name: 'GiftCards' }">
                        - Poklon kodovi
                      </router-link>
                    </li>

                    <li v-if="hasPermission('Vidi newsletter korisnike')">
                      <router-link exact class="nav-link" :to="{ name: 'Newsletters' }">
                        - Newsletter korisnici
                      </router-link>
                    </li>
                  </ul>
                </li>

                <li class="nav-parent" v-if="hasPermission('Vidi \'B2B Postavke\'')">
                  <a class="nav-link" href="#">
                    <i class="bx bxs-component" aria-hidden="true"></i>
                    <span>B2B Postavke</span>
                  </a>
                  <ul class="nav nav-children">
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'GeneralSettings' }"
                      >
                        - Opće postavke
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'ArticleSettings' }"
                      >
                        - Postavke artikala
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'CustomerSettings' }"
                      >
                        - Korisničke postavke
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'OrderSettings' }"
                      >
                        - Postavke narudžbi
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'ShippingSettings' }"
                      >
                        - Postavke dostave
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'TaxSettings' }"
                      >
                        - Postavke poreza
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'ShoppingCartSettings' }"
                      >
                        - Postavke košarice
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'BlogSettings' }"
                      >
                        - Postavke novosti
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'MediaLibrarySettings' }"
                      >
                        - Postavke biblioteke
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'LanguageSettings' }"
                      >
                        - Postavke jezika
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'UserArticlesSettings' }"
                      >
                        - Postavke proizvoda za vas
                      </router-link>
                    </li>
                    <!-- <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'OfferSettings' }"
                      >
                        - Postavke ponuda
                      </router-link>
                    </li> -->
                    <!-- <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'Settings' }"
                      >
                        - Parametri
                      </router-link>
                    </li> -->
                  </ul>
                </li>

                <li class="nav-parent" v-if="hasPermission('Vidi \'B2C Postavke\'')">
                  <a class="nav-link" href="#">
                    <i class="bx bxs-component" aria-hidden="true"></i>
                    <span>B2C Postavke</span>
                  </a>
                  <ul class="nav nav-children">
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'B2CGeneralSettings' }"
                      >
                        - Opće postavke
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'B2CArticleSettings' }"
                      >
                        - Postavke artikala
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'B2CCustomerSettings' }"
                      >
                        - Korisničke postavke
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'B2COrderSettings' }"
                      >
                        - Postavke narudžbi
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'B2CShippingSettings' }"
                      >
                        - Postavke dostave
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'B2CTaxSettings' }"
                      >
                        - Postavke poreza
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'B2CShoppingCartSettings' }"
                      >
                        - Postavke košarice
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'B2CBlogSettings' }"
                      >
                        - Postavke novosti
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'B2CMediaLibrarySettings' }"
                      >
                        - Postavke biblioteke
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'B2CUserArticlesSettings' }"
                      >
                        - Postavke proizvoda za vas
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'B2CBestsellersSettings' }"
                      >
                        - Postavke bestsellera
                      </router-link>
                    </li>
                  </ul>
                </li>

                <!-- Todo - Dodati permisiju za Meta SEO -->
                <li class="nav-parent" v-if="hasPermission('Vidi \'Postavke početne stranice\'')">
                  <a class="nav-link" href="#">
                    <i class="bx bxs-tag" aria-hidden="true"></i>
                    <span>Meta SEO</span>
                  </a>
                  <ul class="nav nav-children">
                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'MetaSeoHomepage' }"
                      >
                        - Naslovnica
                      </router-link>
                    </li>

                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'MetaSeoBrands' }"
                      >
                        - Brendovi
                      </router-link>
                    </li>

                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'MetaSeoActions' }"
                      >
                        - Akcije
                      </router-link>
                    </li>

                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'MetaSeoBlogs' }"
                      >
                        - Vijesti
                      </router-link>
                    </li>

                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'MetaSeoAbout' }"
                      >
                        - O nama
                      </router-link>
                    </li>

                    <li>
                      <router-link
                        exact
                        class="nav-link"
                        :to="{ name: 'MetaSeoContact' }"
                      >
                        - Kontakt
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </aside>
      <!-- end: sidebar -->

      <section role="main" class="content-body content-body-modern mt-0">
        <header class="page-header page-header-left-inline-breadcrumb">
          <h2 class="font-weight-bold text-6">{{ route.meta.title }}</h2>
          <div class="right-wrapper" v-if="route.name !== 'Dashboard'">
            <ol class="breadcrumbs">
              <li>
                <span>
                  <router-link :to="{ name: 'Dashboard' }">{{ translations.homePageTitle }}</router-link>
                </span>
              </li>
              <li v-if="parentRoute">
                <router-link :to="{ name: parentRoute.name }">{{
                  parentRoute.meta.title
                }}</router-link>
              </li>
              <li>
                <span>{{ route.meta.title }}</span>
              </li>
            </ol>
          </div>
        </header>
          <router-view />
          <footer class="footer">
            <div class="footer-left">v.{{ versionLabel }}</div>
            <div class="footer-center">Copyright &copy; XSoft 2023</div>
          </footer>
        <Loader />
      </section>
    </div>

    <aside id="sidebar-right" class="sidebar-right">
      <div class="nano">
        <div class="nano-content">
          <a href="#" class="mobile-close d-md-none">
            Collapse <i class="fas fa-chevron-right"></i>
          </a>

          <div class="sidebar-right-wrapper">
            <div class="sidebar-widget widget-calendar">
              <h6>Upcoming Tasks</h6>
              <div data-plugin-datepicker data-plugin-skin="dark"></div>

              <ul>
                <li>
                  <time datetime="2021-04-19T00:00+00:00">04/19/2021</time>
                  <span>Company Meeting</span>
                </li>
              </ul>
            </div>

            <div class="sidebar-widget widget-friends">
              <h6>Friends</h6>
              <ul>
                <li class="status-online">
                  <figure class="profile-picture">
                    <img
                      src="img/!sample-user.jpg"
                      alt="Joseph Doe"
                      class="rounded-circle"
                    />
                  </figure>
                  <div class="profile-info">
                    <span class="name">Joseph Doe Junior</span>
                    <span class="title">Hey, how are you?</span>
                  </div>
                </li>
                <li class="status-online">
                  <figure class="profile-picture">
                    <img
                      src="img/!sample-user.jpg"
                      alt="Joseph Doe"
                      class="rounded-circle"
                    />
                  </figure>
                  <div class="profile-info">
                    <span class="name">Joseph Doe Junior</span>
                    <span class="title">Hey, how are you?</span>
                  </div>
                </li>
                <li class="status-offline">
                  <figure class="profile-picture">
                    <img
                      src="img/!sample-user.jpg"
                      alt="Joseph Doe"
                      class="rounded-circle"
                    />
                  </figure>
                  <div class="profile-info">
                    <span class="name">Joseph Doe Junior</span>
                    <span class="title">Hey, how are you?</span>
                  </div>
                </li>
                <li class="status-offline">
                  <figure class="profile-picture">
                    <img
                      src="img/!sample-user.jpg"
                      alt="Joseph Doe"
                      class="rounded-circle"
                    />
                  </figure>
                  <div class="profile-info">
                    <span class="name">Joseph Doe Junior</span>
                    <span class="title">Hey, how are you?</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </aside>
  </section>
</template>

<script>
import { routes } from '@/router';
import { translations } from '@/mixins';
import Loader from '@/components/shared/Loader.vue';
import helpers from '@/services/helpers';

export default {
  name: 'MainApp',
  mixins: [translations],
  components: {
    Loader,
  },
  data () {
    return {
      versionLabel: '',
    };
  },
  methods: {
    toggleSidebar() {
      const html = document.getElementById('web-shop-app');
      html.classList.toggle('sidebar-left-collapsed');
    },
    toggleSidebarMob() {
      const html = document.getElementById('web-shop-app');
      html.classList.toggle('sidebar-left-opened');
    },
    hasPermission(permission) {
      return helpers.hasPermission(permission, this.userPermissions);
    },
  },
  mounted() {
    helpers.buildSidebarNav();
    this.$store.dispatch('getShowOffers');
    this.$store.dispatch('getShowAdvancedOffers');
    this.versionLabel = process.env.VUE_APP_VERSION;
  },
  computed: {
    getShowOffers() {
      return this.$store.getters.getShowOffers;
    },
    getShowAdvancedOffers() {
      return this.$store.getters.getShowAdvancedOffers;
    },
    profile() {
      return this.$store.getters.getLoggedUser;
    },
    profileInitials() {
      if (!this.profile || !this.profile.firstName || !this.profile.lastName) {
        return '';
      }
      return `${this.profile.firstName[0].toUpperCase()}${this.profile.lastName[0].toUpperCase()}`;
    },
    route() {
      return this.$route;
    },
    parentRoute() {
      return routes[1].children.find(item => {
        return this.$route.meta.parent && item.name === this.$route.meta.parent;
      });
    },
    userPermissions() {
      return this.$store.getters.getLoggedUserPermissions;
    },
  },
};
</script>

<style lang="scss">
@import '/vendor/dropzone/basic.css';
@import '/vendor/dropzone/dropzone.css';
@import './assets/css/theme.css';
@import './assets/css/layouts/modern.css';
@import './assets/css/skins/default.css';

.action-buttons {
  margin-top: 25px;
}

.modal-2xl {
  max-width: 100%;
  height: calc(100vh - 50px);

  .modal-content {
    height: calc(100vh - 50px);
    position: relative;
  }

  .card {
    height: 100%;
  }

  .card-footer {
    position: absolute;
    bottom: 2px;
    left: 0;
    right: 0;
    width: 100%;
  }
}

.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 300px;
  width: calc(100% - 300px);
  font-size: 13px;
  box-shadow: 0px -2px 3px 0px rgba(0,0,0,0.25);
  background: #fff;
  padding: 0.35rem 0;
  z-index: 5;
}

.footer-left {
  position: absolute;
  left: 1rem; /* adjust as needed */
}

.footer-center {
  text-align: center;
}

.sidebar-left-collapsed {
  .footer {
    left: 73px;
    width: calc(100% - 73px);
  }
}

.notifications {
  margin: 4px -25px 0 0 !important;
}
</style>
